import axios from "axios";

//CleverSyncService
export default {
	sync(districtID) {
		return axios.post(`/v1/admin/clever_sync/district/${districtID}`);
	},

	getSyncProgress(districtID) {
		return axios.get(`/v1/admin/clever_sync/progress/${districtID}`);
	},

	syncEvents(districtID) {
		return axios.post(`/v1/admin/event_sync/district/${districtID}`);
	}
};



// WEBPACK FOOTER //
// ./src/services/CleverSyncService.js